/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fresh_Light_Hare_PokeInputs */

const en_fresh_light_hare_poke = /** @type {(inputs: Fresh_Light_Hare_PokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General access`)
};

const de_fresh_light_hare_poke = /** @type {(inputs: Fresh_Light_Hare_PokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemeiner Zugriff`)
};

/**
* | output |
* | --- |
* | "General access" |
*
* @param {Fresh_Light_Hare_PokeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fresh_light_hare_poke = /** @type {((inputs?: Fresh_Light_Hare_PokeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fresh_Light_Hare_PokeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fresh_light_hare_poke(inputs)
	return de_fresh_light_hare_poke(inputs)
});